import { useTranslation } from 'react-i18next'

import Button, { ButtonArrow } from '../../../Button'
import { Counter, TABLE_VARIANT } from '../../../Counter'
import Text from '../../../Text'
import {
  QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_ROW,
  QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_TOGGLE,
} from '../../DashboardBirdview.constants.qa'
import { DashboardSeverityDot } from '../../DashboardSeverityDot'
import { BirdviewAttentionRowAgeSelect } from '../BirdviewAttentionRowAgeSelect'

import * as styles from './BirdviewAttentionRowHeader.module.css'

function BirdviewAttentionRowHeader({
  age,
  count,
  isOpen,
  item,
  onSelectAge,
  onToggle,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.header}>
      <Button.Text
        isGrey
        className={styles.toggle}
        qaName={QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_ROW}
        onClick={onToggle}
      >
        <DashboardSeverityDot tone={item.tone} />
        <Text className={styles.reason}>{t(item.labelKey)}</Text>
        <Counter count={count} variant={TABLE_VARIANT} />
      </Button.Text>
      <div className={styles.actions}>
        <BirdviewAttentionRowAgeSelect age={age} onSelect={onSelectAge} />
        <ButtonArrow
          getTooltip={null}
          isOpen={isOpen}
          qaName={QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_TOGGLE}
          onClick={onToggle}
        />
      </div>
    </div>
  )
}

export default BirdviewAttentionRowHeader
